// HPP: Swatch King leaves Size unpicked (see the inline script in product-variant-picker.liquid) and
// holds Add to cart, but a colour tap makes the theme re-enable the button while the store still has
// the first size in hand. Keep the button held, reading "Select a Size", until a size is actually picked.
// Reads the page only; variant, swatch and cart code untouched.
//
// Fallback (18 Oct 2026, Swatch King outage): when Swatch King is NOT on the page, the theme's own size
// pills show and the theme pre-checks the first size. Until the shopper picks a size themselves, untick
// the size pills and hold the button the same way. Switches itself off the moment Swatch King is back.
(() => {
  if (window.hppSizeGuard) return;
  window.hppSizeGuard = true;

  const BUTTON_TEXT = 'Select a Size';

  // Disable the button and relabel it. "Sold out" and friends are left alone.
  const holdSubmit = (productInfo) => {
    const button = productInfo.querySelector('product-form button[type="submit"]');
    if (!button) return;
    if (!button.hasAttribute('disabled')) button.setAttribute('disabled', 'disabled');
    const label = button.querySelector('span');
    if (label && label.textContent.trim() !== BUTTON_TEXT && !/sold out/i.test(label.textContent)) {
      label.textContent = BUTTON_TEXT;
    }
  };

  const setup = (productInfo) => {
    const isSizeInput = (input) => input && input.type === 'radio' && /^size-\d+/i.test(input.name);
    const sizeInput = Array.from(productInfo.querySelectorAll('input[type="radio"]')).find(isSizeInput);
    if (!sizeInput) return;
    const optionKey = `option${sizeInput.name.match(/-(\d+)/)[1]}`;

    const sizeSwatches = () =>
      Array.from(document.querySelectorAll(`[swatch-option="${optionKey}"]`))
        .map((swatch) => swatch.closest('li[role="radio"]'))
        .filter(Boolean);
    const sizeChosen = () => sizeSwatches().some((item) => item.getAttribute('aria-checked') === 'true');

    // Swatch King is "on the page" if its data or any of its buttons exist (it may draw them a moment late).
    const swatchKingPresent = () =>
      Boolean(window.vskData || window.vsk_data || document.querySelector('[swatch-option]'));

    // Has the shopper chosen a size on the theme's own pills? Set only by a real tap/click/key press on a
    // size pill. Lives here, on the product-info element's closure, so it survives the theme's re-renders.
    let shopperPickedSize = false;
    productInfo.addEventListener('change', (event) => {
      if (event.isTrusted && isSizeInput(event.target)) shopperPickedSize = true;
    });

    const holdButton = () => {
      // Only act once Swatch King has drawn the size buttons; without them the theme's own buttons show S.
      if (sizeSwatches().length < 2 || sizeChosen()) return;
      holdSubmit(productInfo);
    };

    // Fallback for the theme's own size pills (Swatch King absent).
    const holdNativeSize = () => {
      if (shopperPickedSize || swatchKingPresent()) return;
      // The theme re-renders the pills after any option change with the first size ticked; untick again.
      // (Setting .checked fires no change event, so the theme's colour/price/URL updates are not disturbed.)
      productInfo.querySelectorAll('input[type="radio"]').forEach((input) => {
        if (isSizeInput(input) && input.checked) input.checked = false;
      });
      holdSubmit(productInfo);
    };

    const hold = () => {
      holdButton();
      holdNativeSize();
    };

    new MutationObserver(hold).observe(productInfo, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-checked'],
    });
    hold();
  };

  const init = () => document.querySelectorAll('product-info').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
